import React from 'react';

import { Map } from 'ha/components/Gallery/components/Map';
import { Coords } from 'ha/modules/GoogleMap';
import { useFeatureFlags } from 'ha/modules/FeatureFlags';
import { Experiment, Variant } from 'ha/modules/Experiments';
import { Experiments } from 'ha/constants/experiments';

import { GalleryMapTopPlace } from './GalleryMapTopPlace';

interface Props {
  coordinates: Coords;
}

export const GalleryMap: React.FC<Props> = ({ coordinates }) => {
  const { ldpTopPlace } = useFeatureFlags();

  return ldpTopPlace === 'on' ? (
    <Experiment name={Experiments.TNT809.name}>
      <Variant name="A">
        <Map coordinates={coordinates} touchZoom />
      </Variant>
      <Variant name="B">
        <GalleryMapTopPlace />
      </Variant>
    </Experiment>
  ) : (
    <Map coordinates={coordinates} touchZoom />
  );
};
